<template>
  <div>
    <zoom-info-form
      :form-props="form"
      :is-edit="true"
      title="zoom_meeting.zoom_meeting_detail"
      @generateNewZoom="generateNewZoom"
      ref="infoFormRefs"
      @submitForm="editForm"
    ></zoom-info-form>
  </div>
</template>
<script>
import ZoomInfoForm from "./Components/ZoomInfoForm";
import { service_paths, service_names } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import { zoom_meeting_names } from "../../routes/routes";
import pick from "lodash/pick";
import { genWeeklyRepeatOn } from "./Components/ultils";
import cloneDeep from "lodash/cloneDeep";
import { KEY_GENERATE_ZOOM, MEETING_TYPE } from "./Components/ultils";

export default {
  components: { ZoomInfoForm },
  created() {
    this.fetchZoomMeetingInfo();
  },
  data() {
    return {
      form: {},
      componentKey: null,
      defaultForm: null,
      defaultParticipant: null
    };
  },
  computed: {
    zoomId() {
      return this.$route.params.id;
    }
  },
  methods: {
    buildFormGenerate(form) {
      const formRequest = cloneDeep(form);
      if (formRequest.zoom_meeting_type === MEETING_TYPE.recurring) {
        return this.formGenerateRecurring(formRequest);
      }
      return this.formGenerateSchedule(formRequest);
    },
    formGenerateSchedule(form) {
      let baseForm = pick(form, KEY_GENERATE_ZOOM.form);
      let time = form.calendar.start_date_time.split(" ")[0];
      return {
        ...baseForm,
        start: time,
        end: time,
        id: this.defaultForm?.id,
        host_ui_id: form.host_ui_id,
        uuid: this.defaultForm?.uuid,
        repeat: "daily"
      };
    },
    formGenerateRecurring(form) {
      let baseForm = pick(form, KEY_GENERATE_ZOOM.form);
      const getListRepeat = repeatOn => {
        if (!repeatOn) return;
        let days = [];
        repeatOn.forEach(item => {
          days = [...days, item.day_of_week];
        });
        return days;
      };
      return {
        ...baseForm,
        repeat: form.calendar?.repeat,
        uuid: this.defaultForm?.uuid,
        start: form.calendar?.start,
        end: form.calendar?.end,
        id: this.defaultForm?.id,
        host_ui_id: form.host_ui_id,
        repeat_on: getListRepeat(form.calendar?.repeat_on)
      };
    },
    generateNewZoom(form) {
      const formRequest = this.buildFormGenerate(form);
      this.$axios
        .post(
          `${service_names.school}/zoom-meeting/${this.zoomId}/generate-link`,
          formRequest
        )
        .then(({ data }) => {
          this.$refs.infoFormRefs.form.link_zoom = data.link_zoom;
          this.$refs.infoFormRefs.form.pmi = data.pmi;
          Message.success(this.$t("zoom_meeting.generate_link_success"));
        });
    },
    editForm(form) {
      const path = `${service_names.school}/zoom-meeting/${this.zoomId}`;
      this.$axios.put(path, form).then(() => {
        Message.success(this.$t("common.edit_success"));
        this.$router.push({ name: zoom_meeting_names.listPage });
      });
    },
    async fetchZoomMeetingInfo() {
      const response = await this.$axios.get(
        `${service_names.school}/zoom-meeting/${this.zoomId}`
      );
      this.defaultForm = cloneDeep(response.data);
      this.setFormCreate(response.data);
    },
    setFormCreate(data) {
      this.setStatusCreate(true);
      let calendar = this.setCalendar(data);
      calendar = {
        ...this.$refs.infoFormRefs.calendar,
        ...calendar
      };
      this.$refs.infoFormRefs.calendar = calendar;
      this.$refs.infoFormRefs.cpnKeyDatetime++;
      this.$nextTick(() => {
        this.setStatusCreate(false);
      });
      this.fetchParticipant();
    },
    setStatusCreate(status) {
      this.$refs.infoFormRefs.isCreateStart = status;
      this.$refs.infoFormRefs.isCreateEnd = status;
      this.$refs.infoFormRefs.isCreateRepeatOn = status;
    },
    setCalendar(data) {
      const meetingType = data.zoom_meeting_type;
      if (meetingType !== MEETING_TYPE.schedule) {
        return {
          repeat: data.repeat,
          repeat_on: this.setRepeatOn(data.repeat_on, data.start, data.end),
          from_time: data.from_time,
          start: data.start,
          start_date_time: "",
          end: data.end
        };
      } else {
        return {
          repeat: "weekly",
          repeat_on: [],
          from_time: data.from_time,
          start: null,
          start_date_time: data.start + " " + data.from_time,
          end: null
        };
      }
    },
    setRepeatOn(repeatOn, start, end) {
      if (!repeatOn) return;
      let listRepeatOn = genWeeklyRepeatOn(start, { end: end });
      return listRepeatOn.map(item => {
        let condition = !!repeatOn.includes(item.day_of_week);
        item.from_time = repeatOn[0]?.from_time || "";
        return {
          ...item,
          isActivated: condition
        };
      });
    },
    initDataProps(studentAttendance) {
      this.form = {
        ...this.defaultForm,
        student_attendance: studentAttendance
      };
    },
    async fetchParticipant() {
      const path = `${service_names.school}/zoom-meeting/${this.zoomId}/participant`;
      const { data } = await this.$axios.get(path, { limit: 300 });
      this.defaultParticipant = cloneDeep(data);
      this.setListParticipant(data);
    },
    setListParticipant(data) {
      this.$refs.infoFormRefs.isCreate = true;
      const studentAttendance = !!data?.data[0]?.student_attendance;
      this.initDataProps(studentAttendance);
      const selectedList = data.data.map(item => {
        let condition = item.type_guest === "class";
        item = condition ? item.classes : item.user;
        let display = condition
          ? item.name
          : item?.full_name + " - " + item?.email + " - " + item?.student_code;
        return { ...item, display };
      });
      this.$refs.infoFormRefs.memorizedSelected = selectedList;
      this.$nextTick(() => {
        this.$refs.infoFormRefs.isCreate = false;
      });
    }
  }
};
</script>
